import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ba615be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-1 font-semibold" }, "Duyệt V/tư", -1))
const _hoisted_4 = {
  key: 0,
  class: "vat-tu-reserve-alert my-3 w-100 d-flex align-items-center rounded px-3 py-2 bg-warning bg-opacity-10 border border-warning text-warning fs-6 fw-medium",
  role: "alert"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge bg-warning text-dark me-2" }, "Cần cập nhật", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "⚠"),
  /*#__PURE__*/_createTextVNode(" Mức dự trữ tối thiểu hoặc tối đa đang bằng 0. Vui lòng cập nhật giá trị phù hợp. ")
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "fw-bolder vat-tu-multiline-text" }
const _hoisted_9 = { class: "fw-bolder vat-tu-multiline-text" }
const _hoisted_10 = { class: "my-3 w-100" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex align-items-center rounded px-3 py-2 bg-success bg-opacity-10 border border-success border-opacity-50 text-success fs-6 fw-medium",
  role: "status"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "✓"),
  /*#__PURE__*/_createTextVNode(" Dữ liệu vật tư đã được kiểm duyệt và sử dụng trong hệ thống quản lý ")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "d-flex align-items-center rounded px-3 py-2 bg-warning bg-opacity-10 border border-warning border-opacity-50 text-warning fs-6 fw-medium",
  role: "alert"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "⚠"),
  /*#__PURE__*/_createTextVNode(" Vật tư mới cần được phê duyệt để sử dụng làm dữ liệu cho toàn hệ thống ")
], -1))
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_ConfirmationApproveDialog = _resolveComponent("ConfirmationApproveDialog")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_Can = _resolveComponent("Can")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      width: "20%",
      "is-display": _ctx.isDeleteVatTuDialogDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDeleteVatTuDialogDisplay = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeleteVatTuDialogDisplay = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_1, [
          _createTextVNode(" Bạn hãy chắc chắn muốn xóa vật tư "),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.vatTuDetail?.ten_vat_tu), 1),
          _createTextVNode("? ")
        ])
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_ConfirmationApproveDialog, {
      "approve-type": "VAT_TU",
      "is-display": _ctx.showApproveVatTuDialog,
      "vat-tu": _ctx.vatTuDetail ?? undefined,
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showApproveVatTuDialog = false)),
      onOnConfirm: _cache[3] || (_cache[3] = 
      () => {
        _ctx.showApproveVatTuDialog = false;

        _ctx.fetchedSupplyDetail();
      }
    )
    }, null, 8, ["is-display", "vat-tu"]),
    _createVNode(_component_PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_PageContentSection, { "always-expanded": true }, {
          header: _withCtx(() => [
            _createTextVNode(" Thông tin ")
          ]),
          actions: _withCtx(() => [
            (!_ctx.isInaccessible && _ctx.vatTuDetail)
              ? (_openBlock(), _createBlock(_component_Can, {
                  key: 0,
                  all: [_ctx.VAT_TU.SUA]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.EDIT,
                      "color-type": _ctx.ButtonTypeColors.PRIMARY,
                      "tooltip-message": "Chỉnh sửa thông tin vật tư",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.push(`/quan-ly/vat-tu/cap-nhat/${_ctx.vatTuDetail?.id}`)))
                    }, null, 8, ["button-type", "color-type"])
                  ]),
                  _: 1
                }, 8, ["all"]))
              : _createCommentVNode("", true),
            (_ctx.vatTuDetail?.is_valid === 0)
              ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                  key: 1,
                  "color-type": _ctx.ButtonTypeColors.SUCCESS,
                  "button-type": _ctx.ButtonsType.MEMO_CIRCLE_CHECK_CLASSIC_SOLID,
                  "is-disabled": !_ctx.canDuyetVatTu,
                  "tooltip-message": !_ctx.canDuyetVatTu ? 'Bạn không có quyền này' : '',
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showApproveVatTuDialog = true))
                }, {
                  "button-label": _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["color-type", "button-type", "is-disabled", "tooltip-message"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_ctx.hasZeroReserve)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
              : _createCommentVNode("", true),
            _createVNode(_component_ResponsiveLayout, { "margin-y": "my-2" }, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" ID: ")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.vatTuDetail?.id), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Tên vật tư: ")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.vatTuDetail?.ten_vat_tu), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, { "margin-y": "my-2" }, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mã vật tư: ")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.vatTuDetail?.ma_vat_tu), 1)
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Đơn vị tính: ")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.vatTuDetail?.don_vi_tinh ? _ctx.vatTuDetail.don_vi_tinh : '-'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, { "margin-y": "my-2" }, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mức dự trữ tối thiểu: ")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                (_ctx.vatTuDetail)
                  ? (_openBlock(), _createBlock(_component_LabelCustom, {
                      key: 0,
                      "is-bolder": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatQuantity(_ctx.vatTuDetail.muc_du_tru_toi_thieu ?? 0)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mức dự trữ tối đa: ")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                (_ctx.vatTuDetail)
                  ? (_openBlock(), _createBlock(_component_LabelCustom, {
                      key: 0,
                      "is-bolder": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatQuantity(_ctx.vatTuDetail.muc_du_tru_toi_da)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, { "margin-y": "my-2" }, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Đặc tính: ")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.vatTuDetail?.dac_tinh || '-'), 1)
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ghi chú: ")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.vatTuDetail?.note || '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, { "margin-y": "my-2" }, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Thời gian tạo: ")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                (_ctx.vatTuDetail)
                  ? (_openBlock(), _createBlock(_component_LabelCustom, {
                      key: 0,
                      "is-bolder": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.vatTuDetail.created_at).format('DD/MM/YYYY HH:mm:ss')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Thời gian cập nhật: ")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                (_ctx.vatTuDetail)
                  ? (_openBlock(), _createBlock(_component_LabelCustom, {
                      key: 0,
                      "is-bolder": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.vatTuDetail.updated_at).format('DD/MM/YYYY HH:mm:ss')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_ResponsiveLayout, { "margin-y": "my-2" }, {
              "col-1": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Tạo v/tư thu hồi: ")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                (_ctx.vatTuDetail)
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 0,
                      id: "is-thu-hoi",
                      "model-value": _ctx.vatTuDetail.thu_hoi,
                      disabled: "",
                      size: "large"
                    }, null, 8, ["model-value"]))
                  : _createCommentVNode("", true)
              ]),
              "col-3": _withCtx(() => [
                _createVNode(_component_LabelCustom, { isTextMuted: "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cty quản lý: ")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                (_ctx.vatTuDetail)
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 0,
                      id: "is-cong-ty-duyet",
                      "model-value": _ctx.vatTuDetail.cong_ty_duyet,
                      disabled: "",
                      size: "large"
                    }, null, 8, ["model-value"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.vatTuDetail?.is_valid === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}